"use client";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import Icon from "../icons/Icons";
import { PortfolioPlanCardProps } from "@/type/servicesPageTypes";
import PortfolioModel from "@/app/portfolio-services/portfolio-components/model/PortfolioModel";

export default function PortfolioServicesCard({
  subtitle,
  title,
  priceNote,
  includes,
  footerNote,
  buttonText,
  buttonUrl,
  icon,
  isDirect,
  defaultOpen,
  investment,
  quesData,
  isHighlighted,
  isAssessmentSubmitted,
}: PortfolioPlanCardProps & { isHighlighted?: boolean }) {
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 1280 && defaultOpen) {
      setOpen(false);
    }
  }, [defaultOpen]);

  return (
    <div
      className={`group max-w-96 pb-0 xs:pb-7 xl:min-w-127 overflow-hidden transition shadow-[0px_10px_33px_-7px_#00000026] rounded-4xl sm:rounded-8xl ${isHighlighted ? "border-(--primary) bg-linear-to-b/srgb from-[rgb(var(--primary-alpha)/0.1)] to-[#FFFFFF] border-2 scale-[1.02]" : "bg-[#F6F6F6] border-2 border-[#FFFFFF] hover:border-(--primary) hover:bg-linear-to-b/srgb hover:from-[rgb(var(--primary-alpha)/0.1)] hover:to-[#FFFFFF]"}`}
    >
      <div className="p-4 xl:px-7 xl:pt-6">
        <div className="flex justify-between">
          <p className="text-xs text-[#4A5565] px-4 flex items-center justify-center h-fit py-1.5  border w-fit rounded-full">
            {subtitle}
          </p>
          <Image
            src={`/next_assets/images/portfolio-services/${icon}.png`}
            alt={title}
            width={44}
            height={44}
          />
        </div>

        <div className="font-semibold text-xl xl:text-2xl mt-4 xl:mt-5">
          {title}
        </div>

        <div className="flex items-center gap-2 mt-4">
          <p className="text-(--primary) font-bold text-2xl sm:text-3xl">
            <span className="line-through font-semibold text-1.5xl sm:text-2.5xl">
              ₹{investment}
            </span>{" "}
            Free
          </p>
          <p className="pt-2 text-[#6A7282] text-sm">/ {priceNote}</p>
        </div>
        <div
          className={`overflow-hidden transition-all duration-500 ease-in-out  ${!isDirect ? "opacity-100 mt-4 xl:mt-5" : "max-h-0 opacity-0 mt-0"} `}
        >
          <div className="p-4 border border-[#E2E4E9] bg-white rounded-2xl">
            <p className="text-base italic text-[#5F5F5F] leading-1.3 font-medium ">
              One-time{" "}
              <span className="leading-1.3 text-black italic font-semibold">
                ₹{investment}
              </span>{" "}
              Investment in a Liquid/Debt Fund.
            </p>
          </div>
        </div>
      </div>
      <div
        className={`overflow-hidden transition-all duration-300 px-4 pb-4 xs:pb-0 xl:px-7 xl:pb-4
           xs:max-h-none xs:opacity-100
             ${open ? "max-h-screen opacity-100" : "max-h-0 opacity-0 pb-0!"}
           `}
      >
        <p className="text-xs  text-[#6A7282] tracking-wide uppercase mb-3 border-t pt-5">
          Includes
        </p>

        <div className="xl:grid xl:grid-cols-2 mb-2.5 border-b xl:min-h-100 items-stretch">
          {includes.map((item, i) => (
            <p key={i} className="text-sm text-[#4A5565] pb-2  flex flex-1 ">
              <Icon.rightSignIcon className="h-3 w-5 mt-1 text-[#009966] shrink-0" />{" "}
              {item}
            </p>
          ))}
        </div>
        <p className="flex items-center justify-center  text-[#6A7282] my-4 text-xs gap-2">
          <span>
            <Icon.limitedICon />{" "}
          </span>
          {footerNote}
        </p>

        <Link
          href={`/portfolio-services/${buttonUrl}`}
          className={`bg-white transition-all duration-300 transform group-hover:bg-(--primary) group-hover:text-white mt-4 xl:mt-5 
               rounded-xl gap-x-1.5 items-center w-full py-3 mx-auto flex justify-center text-[#101828] border-2 border-[#B1B1B1] text-sm xl:text-base`}
        >
          <>
            {buttonText} <Icon.dropdownDownArrow className="-rotate-90" />
          </>
        </Link>
      </div>
      {openModal && (
        <PortfolioModel
          quesData={quesData || []}
          url={buttonUrl}
          onClose={() => setOpenModal(false)}
        />
      )}

      <div className="mx-auto xs:hidden bg-[#EDF4FF] w-full ">
        <button
          onClick={() => setOpen(!open)}
          className="w-full flex justify-center py-3"
        >
          <Icon.dropdownDownArrow
            className={`transition-transform duration-300 ${open ? "rotate-180" : ""}`}
          />
        </button>
      </div>
    </div>
  );
}
